import { useState, useMemo, useCallback, useEffect } from 'react';
import { Box, ButtonBase, makeStyles, Popover } from '@material-ui/core';
import _ from 'lodash';
import { AutoCompleteSelect, Dialog } from '../../../../components';
import Text from '../../../../components/Text';
import { AddIcon } from '../../../../components/Icon';
import StyleInput from '../../../../components/StyleInput';
import { eadmissionAPI } from '../../../../apis';
import { i18n } from '../../../../language';

const useStyles = makeStyles(() => ({
  btn: {
    color: '#538FFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
  },
  addIcon: {
    fontSize: '1rem',
    marginRight: '0.38rem',
  },
  remarkColorPopup: {
    zIndex: '9999',
  },
  item: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    padding: '6px 16px',
    justifyContent: 'flex-start',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: '#f1f6ff',
      color: '#538fff',
    },
  },
}));

function SelectLocation({ handleClose, locationList, handleCommandCentre }) {
  const [form, setForm] = useState({
    location: '',
  });
  console.log('form', form);

  const handleUpdateForm = (key) => (value) => {
    setForm((preForm) => ({
      ...preForm,
      [key]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      await handleCommandCentre(
        _.find(locationList, (item) => `${item.hospCode}-${item.wardLocation}` === form.location)
      );
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  const submitDisable = useMemo(() => {
    return !form.location;
  }, [form.location]);

  return (
    <Dialog
      handleClose={handleClose}
      handleConfirm={handleSubmit}
      handleCancel={handleClose}
      open={true}
      width="44.375rem"
      title={i18n.t('BEDSTATUS_COMMAND_CENTRE_LOCATION_POPUP_TITLE')}
      confirm={i18n.t('BEDSTATUS_COMMAND_CENTRE_LOCATION_POPUP_CONFIRM')}
      cancel={i18n.t('BEDSTATUS_COMMAND_CENTRE_LOCATION_POPUP_CANCEL')}
      disabled={submitDisable}
    >
      <Box display="flex" flexDirection="column" gridGap="1.88rem">
        <Box display="flex" flexDirection="column" gridGap="0.63rem">
          <Box display="flex" justifyContent="space-between">
            <Text color="#2E4469" fontSize="1rem">
              {i18n.t('BEDSTATUS_COMMAND_CENTRE_LOCATION_POPUP_INPUT_TITLE')}
            </Text>
          </Box>
          <AutoCompleteSelect
            value={form.location}
            onChange={handleUpdateForm('location')}
            itemList={_.map(locationList, (item) => ({
              text: `${item.hospCode}-${item.wardLocation}`,
              value: `${item.hospCode}-${item.wardLocation}`,
            }))}
            placeholder="Ward Location"
          />
        </Box>
      </Box>
    </Dialog>
  );
}

export default SelectLocation;
